import * as React from 'react';

const NoMatch: React.StatelessComponent = () => {
  return <div>No Match</div>;
};

export default NoMatch;



// WEBPACK FOOTER //
// ./src/components/NoMatch.tsx